import type { FaireProductEntity } from "../../entity_types/product";

export const p_phpbstm6xx: FaireProductEntity = {
  token: "p_phpbstm6xx",
  type: "product",
  name: "Tangerine Sunshine - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/fe74ed3aed5f07e3ebd15ead23e3ba3623fc80c30cd0d836d422357adefaa87e.jpeg",
  galleryImageUrls: [],
  priceDollars: 9.8,
  description: "SUPERFOOD TEA BLEND\n\nCitrus Squeeze!\n\nThe sun’s out, the oranges are juicy, and the tea is served! Sip and soak up sunny citrus flavours with this nourishing, superfruit blend. Real orange peel, mango, tangerine, and turmeric will pep you up, support glow, and immunity too! The hint of vanilla bean channels your favourite creamsicle pop - delicious with a splash of milk and honey! \n\n100% ORGANIC - NUTRITIONIST FORMULATED - SUGAR FREE \n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Ice it: Steep tea double-strength for at least 5 minutes. Top with a heaping cup of ice. Sweeten to taste and add a squeeze of lemon, if desired. \n * Cold-brew: Brew it overnight with cold water \nWhen to Steep:\n\n * A soothing all day caffeine-free tea. \n * To assist with digestion between meals. \n * To boost hydration. \n * To bolster immunity. \nCaffeine-free\n",
  tags: [],
  msrpDollars: 15.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:46.238Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
